import { Dropdown } from '@makemydeal/dr-shared-components';
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { PostalCodeInput } from '@makemydeal/dr-shared-components/postal-code-input';

import { tradeInContainerGridProps, tradeInContainerLargeFieldsProps } from './utils';
import { StyledDatePicker } from './LienholderForm.interstate.style';
import { useSelector } from 'react-redux';
import { Grid } from '@interstate/components/Grid';
import { useMediaQuery } from 'react-responsive';
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import { PhoneInput } from '@makemydeal/dr-shared-components/phone-input';
import { LienholderField } from './LienholderField';
import { useLienholderFormInputs } from './useLienholderFormInputs';
import type { LienholderFormInputsProps } from './lienholderFormTypes';

export type { LienholderFormInputsProps } from './lienholderFormTypes';

const LienholderFormInputs = (props: LienholderFormInputsProps) => {
    const { isOutsideLienholder = false } = props;
    const {
        lienholderFieldProps,
        accountNumberProps,
        payoffDueDateProps,
        perDiemProps,
        addressProps,
        cityProps,
        stateProps,
        zipProps,
        phoneProps
    } = useLienholderFormInputs(props);

    const isBreakdownOpen = useSelector(baseDealSelectors.getBreakdownStatus);
    const isLargeScreen = useMediaQuery({ query: `(min-width: 1360px)` });
    const isDealCentralMultiScenario = useSelector(baseDealSelectors.isDealCentralMultiScenario);
    const isCompactUI = useSelector(baseDealSelectors.getCurrentSlideOut) === baseDealActionCreators.SlideOutType.TradeIn;

    const { xs, sm, md, lg, xl } = tradeInContainerGridProps(
        isBreakdownOpen,
        isLargeScreen,
        isDealCentralMultiScenario,
        isCompactUI
    );
    const largeFieldProps = tradeInContainerLargeFieldsProps(
        isBreakdownOpen,
        isLargeScreen,
        isDealCentralMultiScenario,
        isCompactUI
    );

    return (
        <>
            <Grid
                container
                columnSpacing={isDealCentralMultiScenario ? 1 : { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
                rowSpacing={1}
                flexDirection="row"
            >
                <Grid
                    {...largeFieldProps}
                    xs={isOutsideLienholder ? 6 : largeFieldProps.xs}
                    sm={isOutsideLienholder ? 6 : largeFieldProps.sm}
                    md={isOutsideLienholder ? 6 : largeFieldProps.md}
                    lg={isOutsideLienholder ? 5 : largeFieldProps.lg}
                >
                    <LienholderField {...lienholderFieldProps} />
                </Grid>
                {!isOutsideLienholder && (
                    <Grid xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                        <TextInput {...accountNumberProps} />
                    </Grid>
                )}
                {!isOutsideLienholder && (
                    <Grid xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                        <StyledDatePicker {...payoffDueDateProps} />
                    </Grid>
                )}
                {!isOutsideLienholder && (
                    <Grid xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                        <NumericInput {...perDiemProps} />
                    </Grid>
                )}

                <Grid
                    {...largeFieldProps}
                    xs={isOutsideLienholder ? 6 : largeFieldProps.xs}
                    sm={isOutsideLienholder ? 6 : largeFieldProps.sm}
                    md={isOutsideLienholder ? 6 : largeFieldProps.md}
                    lg={isOutsideLienholder ? 5 : largeFieldProps.lg}
                >
                    <TextInput {...addressProps} />
                </Grid>
                <Grid
                    xs={isOutsideLienholder ? 6 : xs}
                    sm={isOutsideLienholder ? 6 : sm}
                    md={md}
                    lg={isOutsideLienholder ? 2 : lg}
                    xl={xl}
                >
                    <TextInput {...cityProps} />
                </Grid>
                <Grid
                    xs={isOutsideLienholder ? 6 : xs}
                    sm={isOutsideLienholder ? 6 : sm}
                    md={md}
                    lg={isOutsideLienholder ? 2 : lg}
                    xl={xl}
                >
                    <Dropdown {...stateProps} />
                </Grid>
                <Grid
                    xs={isOutsideLienholder ? 6 : xs}
                    sm={isOutsideLienholder ? 6 : sm}
                    md={md}
                    lg={isOutsideLienholder ? 2 : lg}
                    xl={xl}
                >
                    <PostalCodeInput {...zipProps} />
                </Grid>
                <Grid
                    xs={isOutsideLienholder ? 6 : xs}
                    sm={isOutsideLienholder ? 6 : sm}
                    md={md}
                    lg={isOutsideLienholder ? 2 : lg}
                    xl={xl}
                >
                    <PhoneInput {...phoneProps} />
                </Grid>
            </Grid>
        </>
    );
};

export default LienholderFormInputs;
